/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  var debugThemeEvents = false;

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    if (!debugThemeEvents) return;
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    if (!debugThemeEvents) return;
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    if (!debugThemeEvents) return;
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { if (debugThemeEvents) console.log(e); });
  document.addEventListener('theme:scroll:up', e => { if (debugThemeEvents) console.log(e); });
  document.addEventListener('theme:scroll:down', e => { if (debugThemeEvents) console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { if (debugThemeEvents) console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

(function (root) {
  var maximumPayments = { weekly: 12, biweekly: 6 };

  function getMaximumPayments(frequency) {
    var maximum = maximumPayments[frequency];
    if (!maximum) throw new Error('Unsupported payment frequency');
    return maximum;
  }

  function calculatePayment(priceCents, paymentCount, frequency) {
    var maximum = frequency ? getMaximumPayments(frequency) : maximumPayments.weekly;
    if (!Number.isFinite(priceCents) || priceCents < 0) throw new Error('Price must be a positive number');
    if (!Number.isInteger(paymentCount) || paymentCount < 2 || paymentCount > maximum) {
      throw new Error('Payment count must be between 2 and ' + maximum);
    }
    return priceCents / paymentCount;
  }

  function formatMoney(cents, currency, locale) {
    return new Intl.NumberFormat(locale || 'en', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }

  root.TMSLayaway = {
    calculatePayment: calculatePayment,
    formatMoney: formatMoney,
    getMaximumPayments: getMaximumPayments
  };

  function initializeCalculator(calculator) {
    if (calculator.dataset.layawayInitialized === 'true') return;

    var trigger = calculator.querySelector('[data-layaway-toggle]');
    var panel = calculator.querySelector('[data-layaway-panel]');
    var frequency = calculator.querySelector('[data-layaway-frequency]');
    var paymentCount = calculator.querySelector('[data-layaway-count]');
    var estimate = calculator.querySelector('[data-layaway-estimate]');
    var schedule = calculator.querySelector('[data-layaway-schedule]');
    var emailLink = calculator.querySelector('[data-layaway-email]');
    if (!trigger || !panel || !frequency || !paymentCount || !estimate || !emailLink) return;

    function populatePaymentCounts() {
      var maximum = getMaximumPayments(frequency.value);
      var previousCount = parseInt(paymentCount.value, 10);
      paymentCount.innerHTML = '';

      for (var count = 2; count <= maximum; count += 1) {
        var option = document.createElement('option');
        option.value = count;
        option.textContent = count + ' payments';
        paymentCount.appendChild(option);
      }

      paymentCount.value = previousCount >= 2 && previousCount <= maximum ? previousCount : maximum;
    }

    function updateEstimate() {
      var count = parseInt(paymentCount.value, 10);
      var priceCents = parseInt(calculator.dataset.price, 10);
      var currency = calculator.dataset.currency || 'USD';
      var locale = document.documentElement.lang || 'en';
      var paymentCents = calculatePayment(priceCents, count, frequency.value);
      var frequencyLabel = frequency.value === 'weekly' ? 'weekly' : 'every two weeks';
      var formattedPayment = formatMoney(paymentCents, currency, locale);

      estimate.textContent = formattedPayment;
      if (schedule) schedule.textContent = count + ' payments, paid ' + frequencyLabel;

      var productTitle = calculator.dataset.productTitle || 'this product';
      var variantTitle = calculator.dataset.variantTitle || '';
      var productLabel = variantTitle && variantTitle !== 'Default Title'
        ? productTitle + ' – ' + variantTitle
        : productTitle;
      var subject = 'Layaway request: ' + productLabel;
      var body = [
        'Hello,',
        '',
        'I am interested in purchasing ' + productLabel + ' through the layaway program.',
        '',
        'Preferred schedule: ' + count + ' payments, paid ' + frequencyLabel,
        'Estimated payment: ' + formattedPayment + ' per payment',
        'Product: ' + (calculator.dataset.productUrl || window.location.href),
        '',
        'Please let me know how to proceed.'
      ].join('\n');
      emailLink.href = 'mailto:shipping@themoonstoned.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    }

    function togglePanel() {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      document.body.classList.toggle('layaway-accordion-open', !isOpen);
      if (!isOpen) updateEstimate();
    }

    populatePaymentCounts();
    updateEstimate();
    trigger.addEventListener('click', togglePanel);
    frequency.addEventListener('change', function () {
      populatePaymentCounts();
      updateEstimate();
    });
    paymentCount.addEventListener('change', updateEstimate);
    calculator.dataset.layawayInitialized = 'true';
  }

  function initializeCalculators(container) {
    var scope = container && container.querySelectorAll ? container : document;
    scope.querySelectorAll('[data-layaway-calculator]').forEach(initializeCalculator);
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initializeCalculators(document); }, { once: true });
    } else {
      initializeCalculators(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initializeCalculators(event.target);
    });

    document.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      var formWrapper = event.target.closest && event.target.closest('[data-product-form-wrapper]');
      var calculator = formWrapper && formWrapper.querySelector('[data-layaway-calculator]');
      if (!calculator) return;
      calculator.dataset.price = variant.price;
      calculator.dataset.variantTitle = variant.title || '';
      var count = calculator.querySelector('[data-layaway-count]');
      if (count) count.dispatchEvent(new Event('change'));
    });
  }
})(globalThis);

(function () {
  function whenReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function initializeAnimations(root) {
    var hero = root.querySelector('[data-cj-hero-content]');
    if (hero) {
      requestAnimationFrame(function () { hero.classList.add('is-visible'); });
    }

    var animated = root.querySelectorAll('[data-cj-animate]:not([data-cj-animation-ready])');
    if (!animated.length) return;

    if (!('IntersectionObserver' in window)) {
      animated.forEach(function (element) {
        element.dataset.cjAnimationReady = 'true';
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var element = entry.target;
        var delay = parseFloat(element.getAttribute('data-cj-delay') || '0');
        window.setTimeout(function () { element.classList.add('is-visible'); }, delay * 1000);
        observer.unobserve(element);
      });
    }, { rootMargin: '-80px 0px' });

    animated.forEach(function (element) {
      element.dataset.cjAnimationReady = 'true';
      observer.observe(element);
    });
  }

  function initializeGallery(gallery) {
    if (gallery.dataset.cjInitialized === 'true') return;

    var dataElement = gallery.querySelector('[data-cj-project-data]');
    var modal = gallery.querySelector('[data-cj-modal]');
    if (!dataElement || !modal) return;

    var projects;
    try {
      projects = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    var video = modal.querySelector('[data-cj-modal-video]');
    var image = modal.querySelector('[data-cj-modal-image]');
    var title = modal.querySelector('[data-cj-modal-title]');
    var badge = modal.querySelector('[data-cj-modal-badge]');
    var description = modal.querySelector('[data-cj-modal-description]');
    var story = modal.querySelector('[data-cj-modal-story]');

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      video.pause();
      video.removeAttribute('src');
      video.load();
    }

    function openModal(index) {
      var project = projects[index];
      if (!project) return;

      if (project.videoUrl) {
        video.src = project.videoUrl;
        video.style.display = 'block';
        image.style.display = 'none';
        video.play().catch(function () {});
      } else if (project.imageUrl) {
        image.src = project.imageUrl;
        image.style.display = 'block';
        video.style.display = 'none';
      }

      title.textContent = project.title || '';
      badge.textContent = project.type || '';
      description.textContent = project.description || '';
      story.textContent = project.story ? '“' + project.story + '”' : '';
      story.style.display = project.story ? 'block' : 'none';
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    gallery.querySelectorAll('[data-cj-project-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openModal(parseInt(trigger.getAttribute('data-cj-project-trigger'), 10));
      });
    });

    modal.querySelectorAll('[data-cj-modal-close]').forEach(function (trigger) {
      trigger.addEventListener('click', closeModal);
    });
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    gallery.dataset.cjInitialized = 'true';
  }

  function initializeInquiry(inquiry) {
    if (inquiry.dataset.cjInitialized === 'true') return;
    var form = inquiry.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      if (form.dataset.klaviyoSubmitted === 'true' || !window.klaviyo) return;

      event.preventDefault();
      form.dataset.klaviyoSubmitted = 'true';

      var field = function (name) {
        var input = form.querySelector('[name="' + name + '"]');
        return input ? input.value.trim() : '';
      };
      var selectedText = function (name) {
        var select = form.querySelector('[name="' + name + '"]');
        return select && select.selectedIndex > 0 ? select.options[select.selectedIndex].text.trim() : '';
      };
      var name = field('contact[name]');
      var nameParts = name.split(/\s+/);
      var properties = {
        'Inquiry source': 'Custom jewellery page',
        'Piece type': selectedText('contact[type]'),
        'Budget range': selectedText('contact[budget]'),
        'Phone number': field('contact[phone]'),
        'Message': field('contact[body]')
      };
      var hasSubmitted = false;
      var submitToShopify = function () {
        if (hasSubmitted) return;
        hasSubmitted = true;
        form.submit();
      };

      try {
        window.klaviyo.identify({
          email: field('contact[email]'),
          first_name: nameParts[0] || '',
          last_name: nameParts.slice(1).join(' '),
          phone_number: properties['Phone number']
        }).then(function () {
          return window.klaviyo.track('Custom Jewelry Inquiry Submitted', properties);
        }).then(submitToShopify).catch(submitToShopify);
        window.setTimeout(submitToShopify, 1500);
      } catch (error) {
        submitToShopify();
      }
    });

    inquiry.dataset.cjInitialized = 'true';
  }

  function initialize(root) {
    initializeAnimations(root);
    root.querySelectorAll('[data-cj-inquiry-link]:not([data-cj-link-ready])').forEach(function (link) {
      link.dataset.cjLinkReady = 'true';
      link.addEventListener('click', function (event) {
        var target = document.getElementById('custom-inquiry-form');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      });
    });
    root.querySelectorAll('[data-cj-gallery]').forEach(initializeGallery);
    root.querySelectorAll('[data-cj-inquiry]').forEach(initializeInquiry);
  }

  whenReady(function () {
    initialize(document);
    document.addEventListener('shopify:section:load', function (event) {
      initialize(event.target);
    });
  });
})();
